import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setElement as setElementInLayoutGroup
} from '../redux/layoutGroups'

export default function * requestChangeLinkInLayoutGroup (action) {
  const { layoutId, id, name, url } = action.payload

  const optimisticAction = yield optimisticPut(setElementInLayoutGroup({
    layoutId,
    elementId: id,
    name,
    url
  }))

  try {
    yield call(apiAction, 'ChangeLinkInLayoutGroup', {
      layoutId,
      id,
      name,
      url
    })
  } finally {
    yield optimisticAction.revert()
  }
}
